import { Box } from '@mui/material'
import React from 'react'
import Purpose from './Purpose'
import Introduction from './Introduction'
import OurServices from './OurServices'
import CoreFeatures from './CoreFeatures'

export default function Home() {
  return (
    <Box>
      <Introduction />
      <CoreFeatures />
      <Purpose />
    </Box>
  )
}
